export default __webpack_public_path__ + "static/media/logo-color.6f73fe86.svg";